export default __webpack_public_path__ + "static/media/empty-folder.87140ce3.svg";